import { gql } from '@apollo/client';

import { BackupMemberFragment } from './backupMembers.fragment';

export * from './backupMemberUpdate.mutation.generated';

export const BACKUP_MEMBER_UPDATE = gql`
  mutation backupMemberUpdate($input: BackupMemberUpdateInput!) {
    backupMemberUpdate(input: $input) {
      errors
      success
      backupMember {
        ...BackupMemberFragment
      }
    }
  }
  ${BackupMemberFragment}
`;
